import React from 'react'
import {
  Button,
  Grid,
  IconButton,
  Typography,
  withStyles
} from '@material-ui/core'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Page } from 'components'
import FilterNoneIcon from '@material-ui/icons/FilterNone';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import ReactGA from "react-ga4";

const styles = (theme) => ({
  root: {
    width: '100%',
    height: '100vh',

    gap: 10
  },
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    width: '100%',
    maxWidth: '450px',
    textAlign: 'center',
  },
  code: {
    color: '#D2222D',
  }
})

const Criamigos = (props) => {
    const { classes } = props

    const CODE = 'QUIERO'

    const handleCopy = () => {
      navigator.clipboard.writeText(CODE);

      toast.success('Código copiado para a área de transferência! 🤩')
    }

  const handleClick = () => {
    ReactGA.event({
      category: "Link Externo",
      action: "open_link_criamigos",
      label: "Criamigos",
    });

    window.open("https://www.mundocriamigos.com.br/loja/#", "_blank");
  };

  return (
      <Page title="Campanha Criamigos">
        <Grid container className={[classes.root, classes.flexColumn]}>
          <Grid item className={classes.flexColumn} style={{ margin: 20, gap: 10 }}>
            <Typography variant="h4" style={{ marginBottom: 10, textAlign: 'center' }}>
              Viva uma experiência fantástica no Mundo Criamigos
            </Typography>

            <Typography className={classes.text}>
              Vem brincar na oficina da diversão com +50 atrações interativas, com atividades para ser vivido em família.
            </Typography>

            <Typography className={classes.text}>
              Usando o cupom de cliente Quiero Fidelidade, <b>1 ingresso para Crianças de 0 a 13 anos é isento de pagamento</b> mediante dois adultos pagantes.
            </Typography>

            <Typography className={classes.text}>
              O cupom é válido para utilização até <b>31/12/2026</b>.
            </Typography>

            <Typography className={classes.text}>
              Basta copiar o código abaixo e colar no campo cupom no site do Criamigos, no momento da compra.
            </Typography>
          </Grid>

          <Grid item className={classes.flexRow}>
            <Typography variant="h3" className={classes.code}>
              {CODE}
            </Typography>

            <IconButton onClick={handleCopy} aria-label="copy">
              <FilterNoneIcon style={{ color: '#D2222D' }} />
            </IconButton>
          </Grid>

          <Grid item>
            <Button
              variant="outlined"
              color="primary"
              endIcon={<OpenInNewIcon />}
              onClick={handleClick}
            >
              Ir para o site
            </Button>
          </Grid>

          <Typography variant="caption" className={classes.text} style={{ marginTop: 10 }}>
            *Regras e regulamento no site Criamigos
          </Typography>
        </Grid>
      </Page>
    )
}

Criamigos.propTypes = {
  classes: PropTypes.object.isRequired
}

const mapStateToProps = (state) => {
  const { loggingIn } = state.authentication
  return {
    loggingIn
  }
}
const connectedCriamigosPage = withRouter(
  connect(mapStateToProps, null, null, {
    pure: false
  })(withStyles(styles)(Criamigos))
)
export { connectedCriamigosPage as Criamigos }
